export function isQuillEmpty(value) {
  const stripped = value.replace(/<(.|\n)*?>/g, '').trim();
  return stripped.length === 0;
};